<template>
  <v-dialog
    v-model="show"
    width="60vw"
  >
    <v-card v-if="show">
      <v-card-title class="align-baseline"
        :class="itemData.Is_Folder ? 'primary--text darken-1' : 'green--text darken-1'"
      >
        {{ isEditMode ? 'Edit' : 'Create' }}
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text class="py-3">
        <v-form
          ref="form"
          v-model="isValid"
          lazy-validation
        >
          <v-row>
            <!-- Is Folder -->
            <v-col cols="12" md="4">
              <v-select
                :color="itemData.Is_Folder ? 'primary' : 'success'"
                dense
                label="Type"
                v-model="itemData.Is_Folder"
                :disabled="isEditMode"
                :items="type"
                item-text="text"
                item-value="isFolder"
                hide-details
                :prepend-icon="itemData.Is_Folder ? 'mdi-folder' : 'mdi-file-code'"
              ></v-select>
            </v-col>
            <!-- /Is Folder -->
            <!-- Name -->
            <v-col cols="12" md="4">
              <v-text-field
                :color="itemData.Is_Folder ? 'primary' : 'success'"
                label="Name"
                counter="100"
                clearable
                dense
                hide-details="auto"
                :rules="[...rules.Name, rules.maxLength(100)]"
                v-model="itemData.Name"
                required
              ></v-text-field>
            </v-col>
            <!-- /Name -->
            <!-- Assignee -->
            <v-col cols="12" md="4">
              <v-autocomplete
                :color="itemData.Is_Folder ? 'primary' : 'success'"
                :label="itemData.Is_Folder ? 'Access To Create Tasks From Report Page' : 'Assigned To'"
                auto-select-first
                clearable
                hide-details="auto"
                dense
                :multiple="itemData.Is_Folder"
                v-model="assigned"
                :small-chips="itemData.Is_Folder"
                deletable-chips
                :items="employeeList"
                item-text="full_name"
                item-value="employee_id"
                :rules="rules.Assignee"
                :required="!itemData.Is_Folder"
              ></v-autocomplete>
            </v-col>
            <!-- /Assignee -->
            <!-- Description -->
            <v-col cols="12" md="8">
              <v-textarea
                dense
                hide-details
                :color="itemData.Is_Folder ? 'primary' : 'success'"
                label="Description"
                v-model="itemData.Description"
                rows="3"
              ></v-textarea>
            <!-- /Description -->
            </v-col>
            <v-col cols="12" md="4">
              <v-row>
                <!-- Start Date -->
                <v-col cols="12" md="6">
                  <DatePicker
                    v-model="itemData.Start_Date"
                    label="Start Date"
                    :color="itemData.Is_Folder ? 'primary' : 'success'"
                    dense
                  />
                </v-col>
                <!-- /Start Date -->
                <!-- Status -->
                <v-col cols="12" md="6">
                  <v-select
                    :color="itemData.Is_Folder ? 'primary' : 'success'"
                    label="Status"
                    hide-details
                    dense
                    v-model="itemData.Status"
                    :items="taskStatuses"
                  ></v-select>
                </v-col>
                <!-- /Status -->
                <!-- Estimate -->
                <v-col cols="12" md="6">
                  <v-text-field
                    v-if="!itemData.Is_Folder"
                    dense
                    :color="itemData.Is_Folder ? 'primary' : 'success'"
                    hide-details="auto"
                    label="Estimate"
                    type="number"
                    v-model="itemData.Estimate"
                    :rules="rules.Estimate"
                    suffix="Hour(s)"
                  ></v-text-field>
                </v-col>
                <!-- /Estimate -->
                <!-- Show in report -->
                <v-col cols="12" md="6">
                  <v-switch
                    class="ma-0"
                    :color="itemData.Is_Folder ? 'primary' : 'success'"
                    dense
                    hide-details
                    v-model="itemData.Show_IN_Report"
                    label="Show In Report"
                  ></v-switch>
                </v-col>
                <!-- /Show in report -->
              </v-row>
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          small
          outlined
          color="primary"
          @click="show = false"
        >
          Cancel
        </v-btn>
        <v-btn
          :disabled="!isValid"
          small
          color="primary"
          @click="submitForm"
        >
          Save
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import { getApiErrorMessage } from '@/utils/apiError'
export default {
  name: 'CRUDTaskOrFolderDialog',
  components: {
    DatePicker: () => import('@/components/global/DatePicker.vue')
  },
  data () {
    return {
      isValid: true,
      primaryStatus: null,
      type: [
        {
          text: 'Folder',
          isFolder: true
        },
        {
          text: 'Task',
          isFolder: false
        }
      ],
      taskStatuses: ['Completed', 'Development', 'Hold', 'Open', 'QA'],
      rules: {
        maxLength: len => v => (v || '').length <= len,
        Name: [v => !!v || 'Field is required'],
        Assignee: [v => this.itemData.Is_Folder ? true : !!v || 'Field is required'],
        Estimate: [
          v => this.itemData.Is_Folder ? true : (!!v || v === '0' || v === 0) || 'Field is required',
          v => !isNaN(v) || 'Only number can be set to the field',
          v => +v >= 0 || 'No negative numbers'
        ]
      }
    }
  },
  mounted () {
    this.primaryStatus = this.itemData.Status
  },
  computed: {
    accessToCreateTasks: {
      get () {
        return this.$store.getters.getAccessToCreateTasksEmplList
      },
      set (val) {
        this.$store.dispatch('updAccessToCreateTasksEmpl', { emplList: val })
      }
    },
    assigned: {
      get () {
        if (this.itemData.Is_Folder) {
          return this.accessToCreateTasks
        } else {
          return this.itemData.Assigned_To
        }
      },
      set (val) {
        if (this.itemData.Is_Folder) {
          this.accessToCreateTasks = val
        } else {
          this.itemData.Assigned_To = val
        }
      }
    },
    show: {
      get () {
        if (this.$store.getters.showEditTaskOrFolderDialog) {
          this.$store.dispatch('getEmployeeList')
          if (this.itemData.Task_ID && this.itemData.Is_Folder) {
            this.$store.dispatch('getAccessToCreateTasksEmpl', {
              projectID: this.itemData.Project_ID,
              taskID: this.itemData.Task_ID
            })
          }
        }
        return this.$store.getters.showEditTaskOrFolderDialog
      },
      set (val) {
        this.$store.dispatch('showEditTaskOrFolderDialog', { show: val, data: null })
      }
    },
    user () {
      return this.$store.getters.getUser
    },
    employeeList () {
      return this.$store.getters.getEmployee
    },
    itemData () {
      return this.$store.getters.getEditTaskOrFolderDialogData
    },
    isEditMode () {
      return this.itemData && this.itemData.Task_ID !== null
    }
  },
  methods: {
    submitForm () {
      this.$refs.form.validate()
      if (this.isValid) {
        if (this.itemData.Task_ID) this.updateTask()
        else this.createNewTask()
      }
    },
    postAccessToCreateTasks (newData, dispatchData, eventType) {
      const pId = this.itemData.Project_ID
      this.axios.post('/api/tasks/access-to-create-tasks', {
        Task_ID: newData.Task_ID,
        Project_ID: this.itemData.Project_ID,
        Access_To_Create_Tasks: this.accessToCreateTasks
      }, {
        headers: {
          Authorization: 'Bearer ' + this.user.token
        }
      }).then(response => {
        this.$store.dispatch('setSuccess', { successMsg: `Task successfully ${eventType}` })
        this.show = false
        this.$emit('updateTasks', pId)
      }).catch(error => {
        const errorMsg = getApiErrorMessage(error)
        this.$store.dispatch('setError', { errorMsg })
      })
    },
    updateTask () {
      let query = `/api/tasks/${this.itemData.Task_ID}`
      if (this.itemData.Is_Folder && this.itemData.Status !== this.primaryStatus) {
        query += `/${true}`
      }
      this.axios.put(query, this.itemData, {
        headers: {
          Authorization: 'Bearer ' + this.user.token
        }
      }).then(response => {
        const pId = this.itemData.Project_ID
        const dispatchData = {
          taskID: this.itemData.Task_ID,
          projectID: this.itemData.Project_ID,
          newData: response.data[0]
        }
        if (response.data[0].Is_Folder) {
          this.postAccessToCreateTasks(response.data[0], dispatchData, 'updated')
        } else {
          this.show = false
          this.$emit('updateTasks', pId)
        }
      }).catch(error => {
        const errorMsg = getApiErrorMessage(error)
        this.$store.dispatch('setError', { errorMsg })
      })
    },
    createNewTask () {
      this.axios.post('/api/tasks', this.itemData, {
        headers: {
          Authorization: 'Bearer ' + this.user.token
        }
      }).then(response => {
        const pId = this.itemData.Project_ID
        const dispatchData = {
          taskID: this.itemData.Parent_Task_ID,
          projectID: this.itemData.Parent_Task_ID,
          self: false,
          newData: response.data[0]
        }
        if (response.data[0].Is_Folder && this.accessToCreateTasks.length > 0) {
          this.postAccessToCreateTasks(response.data[0], dispatchData, 'created')
        } else {
          this.show = false
          this.$store.dispatch('setSuccess', { successMsg: 'Task successfully created' })
          this.$emit('updateTasks', pId)
        }
      }).catch(error => {
        const errorMsg = getApiErrorMessage(error)
        this.$store.dispatch('setError', { errorMsg })
      })
    }
  }
}
</script>
